// eslint-disable-next-line import/prefer-default-export
export enum quizRoutes {
  defaultPath = '/quiz',
  studyDefaultPath = '/tying/quiz',
  quizzesPath = '/quiz/all',
  studyQuizzesPath = '/study/quiz/all',
  createQuizPath = '/quiz/new',
  editQuizPath = '/quiz/edit/:quizId',
  studyCreateQuizPath = '/study/quiz/new',
  createQuizIdPath = '/quiz/new/:quizId',
  studyCreateQuizIdPath = '/study/quiz/:quizId',
  startQuizPath = '/quiz/start',
  studySartQuizPath = '/study/quiz/start',
  questionQuizPath = '/quiz/questions/:questionType/:quizId',
  questionCreateQuizPath = '/quiz/questions/new/:questionType/:quizId',
  questionEditQuizPath = '/quiz/questions/edit/:questionType/:questionId/:quizId',
  studyQuestionQuizPath = '/study/quiz/questions',
  resultQuizPath = '/quiz/result',
  studyResultQuizPath = '/study/quiz/result',
}
